const style = (theme) => ({
  fullWidth: {
    width: '100%',
  },
});

export default style;
